import React, { FC } from "react";
import {
    Autocomplete,
    SxProps,
    Theme,
    TextField
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { IdlocaGeneric } from "../../locales/IdlocaGeneric";
import { Locale } from "../../locales/Locale";

interface IOption {
    id: number | string;
    name: string;
}

export interface IAutocompleteGeneric {
    options: IOption[];
    onChange: (value: string | number | null) => void;
    label: IdlocaGeneric;
    value: string | number | null;
    sx?: SxProps<Theme>;
    getOptionLabel?: (value: string | number) => string;
}

export const AutocompleteGeneric: FC<IAutocompleteGeneric> = ({
    options,
    onChange,
    label,
    value,
    sx,
    getOptionLabel,
}) => {
    const { t } = useTranslation();
    const optionIds = options.map((o) => o.id);

    return (
        <Autocomplete
            options={optionIds}
            getOptionLabel={(optionId) => {
                const option = options.find((o) => o.id === optionId);
                if (!option) return "";

                if (getOptionLabel) {
                    return getOptionLabel(option.id);
                }

                return option.name;
            }}
            value={value}
            onChange={(event, newValue) => onChange(newValue)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={<Locale localeId={label} />}
                    placeholder={t(IdlocaGeneric.start_typing)}
                />
            )}
            isOptionEqualToValue={(optionId, val) => optionId === val}
            sx={sx}
        />
    );
};
